'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popover = require('material-ui/lib/popover/popover');

var _popover2 = _interopRequireDefault(_popover);

var _menu = require('material-ui/lib/menus/menu');

var _menu2 = _interopRequireDefault(_menu);

var _menuItem = require('material-ui/lib/menus/menu-item');

var _menuItem2 = _interopRequireDefault(_menuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var BinaryMacro = function (_Component) {
  _inherits(BinaryMacro, _Component);

  function BinaryMacro(props) {
    _classCallCheck(this, BinaryMacro);

    var _this = _possibleConstructorReturn(this, (BinaryMacro.__proto__ || Object.getPrototypeOf(BinaryMacro)).call(this, props));

    _this.handleRequestClose = function () {
      _this.setState({
        showMacro: false
      });
    };

    _this.styles = require('./BinaryMacro.scss');
    _this.state = {
      showMacro: false,
      leftPos: '0px',
      topPos: '0px',
      macroParent: '',
      macroContainer: '',
      editor: ''
    };
    _this.showMacroFun = _this.showMacro.bind(_this);
    return _this;
  }

  _createClass(BinaryMacro, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keypress', this.showMacroFun, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      document.removeEventListener('keypress', function () {
        _this2.hideMacro();
      }, true);
    }
  }, {
    key: 'onChange',
    value: function onChange(event, value) {
      if (event !== undefined) {
        this.hideMacro();
        if (this.state.editor) {
          this.state.editor.execCommand('mceInsertContent', false, value);
        }
        this.props.onSelect(value, this.state.macroParent);
      }
    }
  }, {
    key: 'getMacroItem',
    value: function getMacroItem() {
      // const data = {'1': {'emailBody': {'[first-name]': 'first-name', '[location-name]': 'location'}, 'emailSubject': {'[location-name]': 'location', '[customre-name]': 'customer', '[provider-name]': 'provider'}}, '2': {'emailBody': {'[first-name]': 'first-name'}, 'emailSubject': {'[first-name]': 'first-name', '[location-name]': 'location', '[customre-name]': 'customer', '[provider-name]': 'provider'}}};
      var data = this.props.macroList.data;
      var campaignMacro = data[this.props.campaignType];
      var containerMacro = campaignMacro !== undefined ? campaignMacro[this.state.macroContainer] : [];
      var DATA = [];

      for (var key in containerMacro) {
        if (containerMacro.hasOwnProperty(key)) {
          DATA.push(_react2.default.createElement(_menuItem2.default, { className: this.styles.binary_macro_item, key: containerMacro[key], value: key, primaryText: containerMacro[key] }));
        }
      }

      return DATA;
    }
  }, {
    key: 'setStateMacroParent',
    value: function setStateMacroParent(parentId) {
      this.setState({ macroParent: parentId, macroContainer: parentId });
    }
  }, {
    key: 'hideMacro',
    value: function hideMacro() {
      this.setState({ showMacro: false });
    }
  }, {
    key: 'showMacro',
    value: function showMacro(event) {
      var leftPos = '0px';
      var topPos = '0px';

      if (event.charCode === 94) {
        // if ^ symbol is pressed, show the macro
        event.preventDefault();
        if (event.target.id !== undefined) {
          var element = document.getElementById(event.target.id);
          this.setStateMacroParent(event.target.id);
          var rect = element.getBoundingClientRect();
          leftPos = rect.left;
          topPos = rect.top;
        }
        if (event.customTarget && event.customTarget.id !== undefined) {
          // const element = document.getElementById('binary_text_rte_ifr').contentWindow.document.getElementById(window.event.customTarget.id);
          var iframe = document.getElementById('binary_text_rte_ifr');
          var frameDoc = iframe.contentDocument || iframe.contentWindow.document;
          var _element = frameDoc.getElementById(event.customTarget.id);
          this.setStateMacroParent('emailBody');
          var _rect = _element.getBoundingClientRect();
          var iframeRect = iframe.getBoundingClientRect();
          leftPos = iframeRect.left + _rect.left;
          topPos = iframeRect.top + _rect.top;
          this.state.editor = event.editor;
        }
        if (event !== undefined) {
          this.setState({
            leftPos: leftPos,
            topPos: topPos,
            showMacro: true,
            anchorEl: event.target
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.state.showMacro && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _popover2.default,
            {
              open: this.state.showMacro,
              style: { left: this.state.leftPos, top: this.state.topPos, height: '150px', overflowY: 'hidden' },
              anchorEl: this.state.anchorEl,
              anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
              targetOrigin: { horizontal: 'left', vertical: 'top' },
              onRequestClose: this.handleRequestClose
            },
            _react2.default.createElement(
              _menu2.default,
              { onChange: this.onChange.bind(this) },
              this.getMacroItem()
            )
          )
        )
      );
    }
  }]);

  return BinaryMacro;
}(_react.Component);

BinaryMacro.propTypes = {
  onSelect: _propTypes2.default.func,
  campaignType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  macroList: _propTypes2.default.object
};
BinaryMacro.defaultProps = {};
exports.default = BinaryMacro;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryMacro/BinaryMacro.js
// module id = 2246
// module chunks = 1